// extracted by mini-css-extract-plugin
export default {"tridi-status-bar":"styles_tridi-status-bar__u0uC4"};